import ChevronDownIcon from '@/components/Icons/ChevronDownIcon';
import ChevronUpIcon from '@/components/Icons/ChevronUpIcon';
import type { CommunityFAQ } from '@/domain/communities';
import type { FC } from 'react';

interface Props {
  faq: CommunityFAQ;
  open?: boolean;
  onOpen: () => void;
  onClose: () => void;
}

const FAQ: FC<Props> = ({ faq, open, onOpen, onClose }) => {
  return (
    <div className="bg-white rounded-none border border-gray-200 overflow-hidden">
      <button
        className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none"
        onClick={() => (open ? onClose() : onOpen())}
      >
        <span className="text-lg font-medium text-gray-900">{faq.question}</span>
        <span className="ml-6 flex-shrink-0">{open ? <ChevronUpIcon /> : <ChevronDownIcon />}</span>
      </button>
      <div
        className={`px-6 transition-all duration-300 ease-in-out ${
          open ? 'max-h-48 py-4 opacity-100' : 'max-h-0 py-0 opacity-0'
        }`}
      >
        <p className="text-gray-600">{faq.answer}</p>
      </div>
    </div>
  );
};

export default FAQ;
